import React from "react";
import { useFormContext, Controller, Control } from "react-hook-form";

import { SelectAsync, Tooltip } from "components";
import { DebounceTimeout } from "globalConstants";
import { FilterColumn } from "types";

import styles from "../filter.module.scss";

type FilterColumnProps = {
	column: FilterColumn;
};

type FilterSelectControlProps = {
	control: Control;
	name?: string;
	isTooltip?: boolean;
	onChange?: Function;
	options?: any;
	columnProps?: { [key: string]: any };
};

const FilterSelectControl = ({
	control,
	name,
	isTooltip,
	onChange,
	...columnProps
}: FilterSelectControlProps) => {
	return (
		<Controller
			name={name || ""}
			control={control}
			defaultValue={null}
			render={({ field }) => (
				<SelectAsync
					{...columnProps}
					debounceTimeout={DebounceTimeout}
					additional={{ page: 0 }}
					cacheOptions
					isDisabled={isTooltip}
					loaderClassName={styles.column}
					{...field}
					onChange={value => {
						field.onChange(value);
						onChange?.(value);
					}}
				/>
			)}
		/>
	);
};

const FilterSelect = ({
	column: { name, isTooltip, tooltipTitle, ...columnProps },
}: FilterColumnProps) => {
	const { control } = useFormContext();

	if (isTooltip) {
		return (
			<Tooltip title={tooltipTitle} className={styles.column}>
				<FilterSelectControl
					control={control}
					name={name}
					isTooltip={isTooltip}
					{...columnProps}
				/>
			</Tooltip>
		);
	} else {
		return (
			<FilterSelectControl
				control={control}
				name={name}
				isTooltip={isTooltip}
				{...columnProps}
			/>
		);
	}
};

export default FilterSelect;
